import { FormInputField, lt } from '@mews/framework';
import { Card, Stack } from '@optimus-web/core';
import { Grid } from '@optimus-web/core/src/Grid';
import { PosMicrosIntegrationTransmissionProtocol } from '@mews-commander/data-access';
import { FieldNames } from './fieldNames';
import { CurrencyField } from './fields/CurrencyField';
import { DetailedBillingField } from './fields/DetailedBillingField';
import { GenerateReversalTransactionField } from './fields/GenerateReversalTransactionField';
import { ReversalPaymasterIdField } from './fields/ReversalPaymasterIdField';
import { MultiDepartmentField } from './fields/MultiDepartmentField';
import { MicrosOutletTable } from './microsOutlets/MicrosOutletTable';

export const ConfigurationDetailForm = ({
    protocol,
    formFormat,
}: {
    protocol: PosMicrosIntegrationTransmissionProtocol;
    formFormat: string;
}) => (
    <Grid
        columnGap="200"
        templateColumns="minmax(0, 2fr) minmax(0, 6fr)"
        height="100%"
        tabletOnly={{
            templateColumns: 'minmax(0, 4fr)',
        }}
        largePhoneOnly={{
            templateColumns: 'minmax(0, 2fr)',
        }}
        phoneOnly={{
            templateColumns: 'minmax(0, 1fr)',
        }}
    >
        <Stack vertical spacing="300">
            <Card padding="200">
                <Stack vertical spacing="200">
                    <CurrencyField />
                    <FormInputField
                        name={FieldNames.ticketNumberLength}
                        label={lt('TicketNumberLength')}
                        type="number"
                        size="medium"
                    />
                    <FormInputField name={FieldNames.paymasterPrefix} label={lt('PaymasterPrefix')} size="medium" />
                    <DetailedBillingField />
                    {formFormat !== PosMicrosIntegrationTransmissionProtocol.XmlPos && (
                        <>
                            <GenerateReversalTransactionField />
                            <ReversalPaymasterIdField />
                            <MultiDepartmentField />
                        </>
                    )}
                </Stack>
            </Card>
        </Stack>
        <Stack vertical spacing="300">
            <Card padding="200">
                <MicrosOutletTable protocol={protocol} formFormat={formFormat} />
            </Card>
        </Stack>
    </Grid>
);
